import { LocalStorageStore, createLocalStorageStore } from '@tcc/shared-data-lib';

// with the solemn vow this prefix is prefixed with "SAFE_TO_PRESERVE."
const KEY_PREFIX = 'fv:canAccessCropPlanning';

const stores = new Map<string, LocalStorageStore<boolean | null>>();

// Keyed by userId to avoid leaking access state across accounts on shared machines
export const getCanAccessCropPlanningStore = (userId: string): LocalStorageStore<boolean | null> => {
  const cached = stores.get(userId);

  if (cached) return cached;

  const key = `${KEY_PREFIX}:${userId}`;
  const store = createLocalStorageStore<boolean | null>({
    key,
    defaultValue: null,
    iSolemnlySwearThereIsNoUserDataInThisKey: true,
    migrateFromLegacyKeys: [key],
  });

  stores.set(userId, store);

  return store;
};
